
import { Job } from './Job'

export class PagedJobsList {
    
 
    pageNo;
    
    index;
    isLastPage;
    jobs;
    stateCounts;            //converted from backend to an array of objects {state: a State enum object, and count: a count of that state}
    
    batchPrintableCount = 0;

    agsBacklog;
    oldestBacklog;
    agsBulkCount;

    //Construct from the backend Json Response
    constructor(json) {
        if (json) {
            this.pageNo = json.pageNo; 
            this.index = json.index;
            this.isLastPage = json.isLast;
            if (json.jobs) {
                this.jobs = json.jobs.map(job => new Job(job));
                for (const job of this.jobs) {
                    if (job.batchPrintable())
                        this.batchPrintableCount++;
                }
            }
            else
                this.jobs = [];
            
           if (json.stateCounts)
                this.stateCounts = json.stateCounts.map(stateCount => { return {state: Job.stateFromString(stateCount.state), count: stateCount.count}; });
           else
                this.stateCounts = [];
            
            this.agsBacklog = json.agsBacklog;
            this.oldestBacklog = json.oldestBacklog;
            this.agsBulkCount = json.agsBulkCount;

        }  
    } 

    static fromSingleJob(job) {
        let pagedList = new PagedJobsList();
        pagedList.pageNo = 0;
        pagedList.index = 0;
        pagedList.isLastPage = true;
        pagedList.jobs = [job];
        if (job.batchPrintable())
            pagedList.batchPrintableCount++;

        // Set all job state enums to 0, then set the one matching the job's state to 1
        pagedList.stateCounts = Object.values(Job.State).map(stateEnum => ({state: stateEnum, count: 0}));
        pagedList.stateCounts.find(sc => sc.state === job.stateEnum).count = 1;
        return pagedList;
    }
    
    isFirst() {
        return this.pageNo === 0;
    }
    
    isLast() {
        return this.isLastPage;
    }
    
}